import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://ideaclap.com";
const DEFAULT_OG_IMAGE = `${SITE_URL}/generated/hero-light.jpg`;

/**
 * Reusable per-page SEO component.
 * Pass title, description, path (e.g. "/about"), and optional image.
 * Sets <title>, meta description, canonical, and full OG/Twitter tags.
 */
export const SEO = ({
    title,
    description,
    path = "/",
    image = DEFAULT_OG_IMAGE,
    type = "website",
    keywords,
    noindex = false,
}) => {
    const url = `${SITE_URL}${path}`;
    const fullTitle = title?.includes("IdeaClap")
        ? title
        : `${title} | IdeaClap Global`;

    return (
        <Helmet prioritizeSeoTags>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            {keywords ? <meta name="keywords" content={keywords} /> : null}
            <link rel="canonical" href={url} />
            {noindex ? (
                <meta name="robots" content="noindex, nofollow" />
            ) : (
                <meta
                    name="robots"
                    content="index, follow, max-image-preview:large, max-snippet:-1"
                />
            )}

            {/* Open Graph */}
            <meta property="og:type" content={type} />
            <meta property="og:site_name" content="IdeaClap Global" />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:image:alt" content={fullTitle} />
            <meta property="og:locale" content="en_US" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            <meta name="twitter:image:alt" content={fullTitle} />
        </Helmet>
    );
};

export default SEO;
